import {IUtility, Utility} from "./helpers/utils/utility";
import {EventTypes} from "./helpers/eventtypes";

class Index {
    utils: IUtility;
    constructor() {
        this.utils = new Utility();
    }
    init() {
       this.utils.hideDiv("spinner");
    }
}
export { Index }
document.addEventListener(EventTypes.DOMContentLoaded, () => {
    let app = new Index();
    app.init();
});
/************************Globals  **********/
function formatBytes(bytes: number): string {
    let units = ['B', 'KB', 'MB', 'GB', 'TB'];
    let i: number;
    for (i = 0; bytes >= 1024 && i < 4; i++) {
        bytes /= 1024;
    }
    return (bytes.toFixed(2) + ' ' + units[i]).toString();
}
/************End Globals****************************/
